import React, { useState } from 'react';
import axios from "axios";

export default function CreateClientModal({ onClose, onUpdateScreen }) {

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        nome: '',
        telefone: '',
        email: '',
        rua: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: '',
        cpf_cnpj: '',
    });

    const [errorMessages, setErrorMessages] = useState({
        nome: '',
        telefone: '',
        email: '',
        rua: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: '',
        cpf_cnpj: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateForm = () => {
        let isValid = true;
        let newErrorMessages = {
            nome: '', telefone: '', email: '', rua: '', bairro: '', cidade: '', estado: '', cep: '', cpf_cnpj: ''
        };

        if (!formData.nome.trim()) {
            newErrorMessages.nome = 'O nome é obrigatório.';
            isValid = false;
        }

        // if (!formData.telefone.trim()) {
        //     newErrorMessages.telefone = 'O telefone é obrigatório.';
        //     isValid = false;
        // }
        //
        // if (!formData.email.trim()) {
        //     newErrorMessages.email = 'O email é obrigatório.';
        //     isValid = false;
        // } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        //     newErrorMessages.email = 'O email é inválido.';
        //     isValid = false;
        // }
        //
        // if (!formData.rua.trim()) {
        //     newErrorMessages.rua = 'A rua é obrigatória.';
        //     isValid = false;
        // }
        //
        // if (!formData.bairro.trim()) {
        //     newErrorMessages.bairro = 'O bairro é obrigatório.';
        //     isValid = false;
        // }
        //
        // if (!formData.cidade.trim()) {
        //     newErrorMessages.cidade = 'A cidade é obrigatória.';
        //     isValid = false;
        // }
        //
        // if (!formData.estado.trim()) {
        //     newErrorMessages.estado = 'O estado é obrigatório.';
        //     isValid = false;
        // }
        //
        // if (!formData.cep.trim()) {
        //     newErrorMessages.cep = 'O CEP é obrigatório.';
        //     isValid = false;
        // }
        //
        // if (!formData.cpf_cnpj.trim()) {
        //     newErrorMessages.cpf_cnpj = 'O CPF/CNPJ é obrigatório.';
        //     isValid = false;
        // } else
        if (formData.cpf_cnpj.trim() & !/^\d{11}$/.test(formData.cpf_cnpj) && !/^\d{14}$/.test(formData.cpf_cnpj)) {
            newErrorMessages.cpf_cnpj = 'O CPF/CNPJ é inválido.';
            isValid = false;
        }

        setErrorMessages(newErrorMessages);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            try {
                setLoading(true);

                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/clientRoutes/clientes`, formData, {
                        headers: {
                            'Content-Type': 'application/json',  // Garantir que o conteúdo seja enviado como JSON
                        },
                    });

                if (response.status === 201) {
                    onUpdateScreen();
                    onClose(); // Fecha o modal
                } else {
                    alert('Ocorreu um erro ao tentar cadastrar o cliente.');
                }

            } catch (error) {
                console.error('Erro ao criar cliente:', error);
                alert('Não foi possível criar o cliente. Tente novamente mais tarde.');
            } finally {
                setLoading(false);
            }

            onClose(); // Fechar o modal após o cadastro bem-sucedido
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-90">
            <div className="glass-panel p-6 w-full max-w-2xl text-white w-300">
                <h2 className="text-xl font-bold text-white mb-6 tracking-wide">Cadastrar Novo Cliente</h2>
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-200">Nome</label>
                            <input
                                type="text"
                                name="nome"
                                value={formData.nome}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.nome ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.nome && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.nome}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">CPF/CNPJ</label>
                            <input
                                type="text"
                                name="cpf_cnpj"
                                value={formData.cpf_cnpj}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.cpf_cnpj ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.cpf_cnpj && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.cpf_cnpj}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">Telefone</label>
                            <input
                                type="text"
                                name="telefone"
                                value={formData.telefone}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.telefone ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.telefone && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.telefone}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.email ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.email && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.email}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">Rua</label>
                            <input
                                type="text"
                                name="rua"
                                value={formData.rua}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.rua ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.rua && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.rua}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">Bairro</label>
                            <input
                                type="text"
                                name="bairro"
                                value={formData.bairro}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.bairro ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.bairro && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.bairro}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">Cidade</label>
                            <input
                                type="text"
                                name="cidade"
                                value={formData.cidade}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.cidade ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.cidade && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.cidade}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">Estado</label>
                            <input
                                type="text"
                                name="estado"
                                value={formData.estado}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.estado ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.estado && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.estado}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-200">CEP</label>
                            <input
                                type="text"
                                name="cep"
                                value={formData.cep}
                                onChange={handleChange}
                                className={`glass-input w-full ${errorMessages.cep ? 'border-red-500' : ''}`}
                            />
                            {errorMessages.cep && (
                                <p className="text-red-500 text-sm mt-1">{errorMessages.cep}</p>
                            )}
                        </div>

                    </div>

                    <div className="flex justify-end space-x-2 mt-10">
                        <button
                            type="button"
                            onClick={onClose}
                            className="glass-button bg-red-500/20 hover:bg-red-500/40 text-red-400"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="glass-button bg-green-500/20 hover:bg-green-500/40 text-green-400"
                        >
                            Cadastrar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
